export const CaretIcon = () => {
  return (
    <svg
      width="55"
      height="26"
      viewBox="0 0 55 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.600098 0.0200195H54.0701L28.8201 25.27L0.600098 0.0200195Z"
        fill="#231F20"
      />
    </svg>
  );
};
